import { ApiMethod } from 'services/api';
import { UseRestMutationOptions, useRestMutation } from 'utils/hooks/api/useRestMutation';

export const CHANGE_CAMPAIGN_STATE_URL = '/campaigns/changeState';

export const useChangeCampaignStateMutation = (options?: UseRestMutationOptions) => {
  const { isLoading, mutate, error } = useRestMutation(
    CHANGE_CAMPAIGN_STATE_URL,
    ApiMethod.post,
    options,
  );

  return { isLoading, mutate, error };
};
